import React from 'react';

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, setActiveTab }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'leads', label: 'Leads', icon: '🎯' },
    { id: 'workorders', label: 'Work Orders', icon: '🔧' },
    { id: 'clients', label: 'Clients', icon: '👥' },
    { id: 'employees', label: 'Employees', icon: '👨‍💼' },
    { id: 'settings', label: 'Settings', icon: '⚙️' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userEmail');
    window.location.href = '/login';
  };

  return (
    <div className="sidebar">
      <div style={{ padding: '20px', borderBottom: '1px solid #2c3e50' }}>
        <h3 style={{ color: '#ecf0f1', margin: 0 }}>HVAC CRM</h3>
      </div>
      
      <nav>
        <ul className="sidebar-menu">
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={activeTab === item.id ? 'active' : ''}
                onClick={() => {
                  setActiveTab(item.id);
                }}
              >
                <span>{item.icon}</span>
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div style={{ position: 'absolute', bottom: '20px', left: '0', right: '0', padding: '0 20px' }}>
        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#e74c3c',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;